import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Grid, Col } from 'components/grid'

import * as S from './styles'

const ICONS_PATH = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/security-fraud/icons`

const About: FC = memo(() => (
  <S.Section $bg="contrast">
    <Grid col={{ phone: 1, tablet: 1, desktop: 12 }} gap={{ phone: 'md', tablet: 'md', desktop: 'md' }}>
      <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
        <Text as="h2" size="heading3" color="var(--colors-primary-text-strong)" weight="medium">
          Saiba mais sobre a{' '}
          <Text as="span" size="heading3" color="var(--colors-pink-text-contrast)" weight="medium">
            CashMe
          </Text>
        </Text>
        <Text color="var(--colors-primary-text-strong)" size="body1">
          Somos uma Fintech que impulsiona projetos de diversos segmentos, por meio de:{' '}
        </Text>
        <S.ItemList>
          <ul className="disc">
            <li>
              <Text color="var(--colors-primary-text-strong)" size="body1">
                Empréstimo com garantia de imóvel
              </Text>
            </li>
            <li>
              <Text color="var(--colors-primary-text-strong)" size="body1">
                Empréstimo para condomínios
              </Text>
            </li>
            <li>
              <Text color="var(--colors-primary-text-strong)" size="body1">
                Empréstimo para construção e término de obras
              </Text>
            </li>
            <li>
              <Text color="var(--colors-primary-text-strong)" size="body1">
                Financiamento imobiliário
              </Text>
            </li>
            <li>
              <Text color="var(--colors-primary-text-strong)" size="body1">
                Projetos de energia solar
              </Text>
            </li>
          </ul>
        </S.ItemList>
        <S.WarningWrapper>
          <S.Warning>
            <S.IconImage>
              <NextImage
                src={`${ICONS_PATH}/lock-and-money-sack.svg`}
                alt="Desenho de um ícone de saco de dinheiro com um cadeado travado no canto inferior esquerdo"
                width="48"
                height="48"
                sizes="100vw"
                style={{
                  width: '100%',
                  height: 'auto'
                }}
              />
            </S.IconImage>
            <Text color="var(--colors-primary-text-strong)" size="body1">
              <b>NÃO</b>
              {' '}
              solicitamos qualquer tipo de pagamento antecipado para aprovar e conceder um empréstimo. {' '}
            </Text>
          </S.Warning>
          <S.Warning>
            <S.IconImage>
              <NextImage
                src={`${ICONS_PATH}/image-and-lock.svg`}
                alt="Desenho de um ícone de imagem com um cadeado travado no canto superior direito"
                width="48"
                height="48"
                sizes="100vw"
                style={{
                  width: '100%',
                  height: 'auto'
                }}
              />
            </S.IconImage>
            <Text color="var(--colors-primary-text-strong)" size="body1">
              <b>NÃO</b>
              {' '}
              entramos em contato sem que uma simulação tenha sido feita no site oficial.{' '}
            </Text>
          </S.Warning>
        </S.WarningWrapper>
      </Col>
    </Grid>
  </S.Section>
))

About.displayName = 'About'

export default About
